export default __webpack_public_path__ + "static/media/light_icon.21eb69ca.svg";